export default "__VITE_ASSET__8be1ae93__"